import { render } from "./user_profile.vue?vue&type=template&id=a8804c42"
import script from "./user_profile.vue?vue&type=script&lang=js"
export * from "./user_profile.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/contragent/user/profile/user_profile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a8804c42"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a8804c42', __exports__)) {
    console.log('reload')
    api.reload('a8804c42', __exports__)
  }
  
  module.hot.accept("./user_profile.vue?vue&type=template&id=a8804c42", () => {
    console.log('re-render')
    api.rerender('a8804c42', render)
  })

}


export default __exports__